import type { LinkSocialPagesBody } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function linkSocialPages(body: LinkSocialPagesBody): Promise<void> {
  await apiClient.url("/social-publishing/pages").post(body).res();
}

export function useLinkSocialPages(): UseMutationResult<
  void,
  Error,
  LinkSocialPagesBody
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: linkSocialPages,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: socialPublishingKeys.pages(),
      });
    },
  });
}
